import React, { useState, useRef } from 'react';
import {
     Apple,
     GitHub,
     ChevronLeft,
     ChevronRight,
     Launch,
     Close,
     ZoomIn,
     Apps,
     Android
} from '@mui/icons-material';
import '../../styles/AppShowcase.scss';

// ============================================================================
// TEMPLATE DATA STRUCTURE FOR SHOWCASE PROJECTS
// To add a new project, simply duplicate one of the objects below and modify its data.
// ============================================================================
const INITIAL_PROJECTS = [
     {
          id: 'appsy-shop',
          name: 'Appsy Shop',
          category: 'E-Commerce',
          tagline: 'React native | E-Commerce App Experience',
          description: 'A sleek mobile shopping experience featuring 10-minute flash drops, 360° product view, live order tracking, and high-conversion instant checkout.',
          icon: require('../../assets/images/appsy_shop/logo.png'),
          liveLink: 'https://apkpure.com/p/com.appsyshop',
          githubLink: 'https://github.com/Garrysahota/AppsyShop',
          appleLink: '',
          playStoreLink: '',
          techStack: ['React Native CLI', 'Redux Toolkit', 'Node.js', 'Stripe'],
          featured: true,
          // Exactly 5 horizontal screenshots (Reference images provided)
          appImages: [
               {
                    id: 1,
                    title: 'Home & Flash Drops',
                    url: require('../../assets/images/appsy_shop/screen1.png'),
                    caption: 'Home'
               },
               {
                    id: 2,
                    title: 'Product Details & 360 View',
                    url: require('../../assets/images/appsy_shop/screen2.png'),
                    caption: 'Product Detail'
               },
               {
                    id: 3,
                    title: 'Search & Trending Kicks',
                    url: require('../../assets/images/appsy_shop/screen3.png'),
                    caption: 'Search & Filters'
               },
               {
                    id: 4,
                    title: 'Bag & Checkout Workflow',
                    url: require('../../assets/images/appsy_shop/screen4.png'),
                    caption: 'Bag & Checkout'
               },
               {
                    id: 5,
                    title: 'Live Delivery Tracking',
                    url: require('../../assets/images/appsy_shop/screen5.png'),
                    caption: 'Live Tracking'
               }
          ]
     },
     {
          id: 'hanggout',
          name: 'Hanggout',
          category: 'Social / Dating App',
          tagline: 'React Native | Real-Life Social & Dating Experience',
          description: 'Meet nearby verified companions with live proximity radar, activity-based hangout invites, and a 24-hour connect window.',
          icon: require('../../assets/images/hookngo/hng_logo.png'),
          liveLink: 'https://apkpure.com/p/com.hookngo',
          githubLink: '',
          // appleLink: 'https://apps.apple.com/in/app/kooie-real-estate/id6737144920',
          // playStoreLink: 'https://play.google.com/store/apps/details?id=com.kooie&hl=en_IN',
          techStack: ['React Native CLI', "Google Auth", 'Firebase & Notifee', 'Google Maps', 'REST API', "Redux Toolkit", "Socket.io", "Razorpay", "Lottie"],
          featured: false,
          appImages: [
               { id: 1, title: 'Discover', url: require('../../assets/images/hookngo/01-discover-1.png'), caption: 'Discover' },
               { id: 2, title: 'Discover', url: require('../../assets/images/hookngo/02-discover-2.png'), caption: 'Discover' },
               { id: 3, title: 'Profile', url: require('../../assets/images/hookngo/03-personal_info.png'), caption: 'Profile' },
               { id: 4, title: 'Invite', url: require('../../assets/images/hookngo/04-invite.png'), caption: 'Invite' },
               { id: 5, title: 'Chat', url: require('../../assets/images/hookngo/05-chat.png'), caption: 'Chat' },
               { id: 6, title: 'Settings', url: require('../../assets/images/hookngo/06-settings.png'), caption: 'Settings' }
          ]
     },
     {
          id: 'brizoo',
          name: 'Brizoo',
          category: 'Ride-Hailing App',
          tagline: 'React Native | Ride-Hailing App',
          description: 'Reliable Cabs, Bikes & Autos at your fingertips with 24/7 SOS safety.',
          icon: require('../../assets/images/brizo/brizo_icon.png'),
          liveLink: 'https://apkpure.com/p/com.brizoo',
          githubLink: '',
          appleLink: '',
          // playStoreLink: 'https://play.google.com/store/apps/details?id=com.crypto.cvtradexchange',
          techStack: ['React Native CLI', 'Google Auth', 'Google Maps', 'Socket.io', 'REST API', "Redux Toolkit", "Lottie", "Navigation"],
          featured: false,
          appImages: [
               { id: 1, title: 'Onboarding', url: require('../../assets/images/brizo/01-onboarding.png'), caption: 'Onboarding' },
               { id: 2, title: 'Sign-in', url: require('../../assets/images/brizo/02-login.png'), caption: 'Sign-in' },
               { id: 3, title: 'Home', url: require('../../assets/images/brizo/03-home.png'), caption: 'Home' },
               { id: 4, title: 'Ride Options', url: require('../../assets/images/brizo/04-ride_options.png'), caption: 'Ride Options' },
               { id: 5, title: 'Ride Tracking', url: require('../../assets/images/brizo/05-tracking.png'), caption: 'Ride Tracking' },
               { id: 6, title: 'Profile', url: require('../../assets/images/brizo/06-profile.png'), caption: 'Profile' }
          ]
     },
     // {
     //      id: 'cv-trade',
     //      name: 'CV Trade',
     //      category: 'Fintech / Crypto',
     //      tagline: 'React Native | Fast Crypto Trading & Exchange',
     //      description: 'High-speed cryptocurrency exchange app supporting real-time market data, spot trading, and instant crypto wallet transfers.',
     //      icon: require('../../assets/images/CVTrade.png'),
     //      liveLink: 'https://cvtrade.io',
     //      githubLink: '',
     //      appleLink: '',
     //      playStoreLink: 'https://play.google.com/store/apps/details?id=com.crypto.cvtradexchange',
     //      techStack: ['React Native', 'Web3.js', 'Chart.js', 'WebSockets'],
     //      featured: false,
     //      appImages: [
     //           { id: 1, title: 'Market Dashboard', url: require('../../assets/images/CVTrade.png'), caption: 'Markets' },
     //           { id: 2, title: 'Crypto Wallet', url: require('../../assets/images/tgw_wallet.png'), caption: 'Wallet' },
     //           { id: 3, title: 'Trading Terminal', url: require('../../assets/images/Bitnetto.png'), caption: 'Trade' },
     //           { id: 4, title: 'Asset Portfolio', url: require('../../assets/images/CVTrade.png'), caption: 'Portfolio' },
     //           { id: 5, title: 'Security Settings', url: require('../../assets/images/tgw_wallet.png'), caption: 'Security' }
     //      ]
     // }
];

const AppShowcase = () => {
     const [activeCategory, setActiveCategory] = useState('All');
     const [selectedImage, setSelectedImage] = useState(null);
     const scrollContainerRefs = useRef({});

     // Extract unique categories for filter tabs
     const categories = ['All', ...new Set(INITIAL_PROJECTS.map(p => p.category))];

     const filteredProjects = activeCategory === 'All'
          ? INITIAL_PROJECTS
          : INITIAL_PROJECTS.filter(p => p.category === activeCategory);

     // Horizontal scrolling handler for screenshot strips
     const handleScroll = (projectId, direction) => {
          const container = scrollContainerRefs.current[projectId];
          if (container) {
               const scrollAmount = direction === 'left' ? -320 : 320;
               container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
          }
     };

     return (
          <section className="__app_showcase_section" id="app-showcase">
               <div className="__showcase_header">
                    <div className="__section_tag">
                         <Apps className="__tag_icon" /> Featured Mobile Applications
                    </div>
                    <h2>Mobile Apps & Live Projects</h2>
                    <p>
                         Explore interactive mobile and web applications built with modern technologies.
                         Scroll horizontally to view app screens or click to inspect full resolution.
                    </p>

                    {/* Category Filter Tabs */}
                    <div className="__category_tabs">
                         {categories.map((cat, idx) => (
                              <button
                                   key={idx}
                                   className={`__tab_btn ${activeCategory === cat ? 'active' : ''}`}
                                   onClick={() => setActiveCategory(cat)}
                              >
                                   {cat}
                              </button>
                         ))}
                    </div>
               </div>

               {/* Projects List */}
               <div className="__showcase_grid">
                    {filteredProjects.map((project) => (
                         <div className="__project_showcase_card" key={project.id}>
                              {/* Card Header Information */}
                              <div className="__card_top">
                                   <div className="__project_identity">
                                        <div className="__app_icon_wrapper">
                                             <img src={project.icon} alt={`${project.name} Icon`} className="__app_icon" />
                                             <span className="__icon_shine"></span>
                                        </div>
                                        <div className="__project_titles">
                                             <div className="__badge_row">
                                                  <span className="__category_badge">{project.category}</span>
                                                  {project.featured && <span className="__featured_badge">Featured</span>}
                                             </div>
                                             <h3>{project.name}</h3>
                                             <p className="__tagline">{project.tagline}</p>
                                        </div>
                                   </div>

                                   {/* Quick Action / Live Links */}
                                   <div className="__action_links">
                                        {project.liveLink && (
                                             <a
                                                  href={project.liveLink}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  className="__live_link_btn"
                                                  title="Visit Live Link"
                                             >
                                                  <Launch /> <span>Live Preview</span>
                                             </a>
                                        )}
                                        {project.appleLink && (
                                             <a
                                                  href={project.appleLink}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  className="__icon_link_btn"
                                                  title="App Store"
                                             >
                                                  <Apple />
                                             </a>
                                        )}
                                        {project.playStoreLink && (
                                             <a
                                                  href={project.playStoreLink}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  className="__icon_link_btn"
                                                  title="Google Play Store"
                                             >
                                                  <Android />
                                             </a>
                                        )}
                                        {project.githubLink && (
                                             <a
                                                  href={project.githubLink}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  className="__icon_link_btn"
                                                  title="Source Code"
                                             >
                                                  <GitHub />
                                             </a>
                                        )}
                                   </div>
                              </div>

                              {/* Description & Tech Stack */}
                              <div className="__card_details">
                                   <p className="__description">{project.description}</p>
                                   <div className="__tech_stack">
                                        {project.techStack.map((tech, i) => (
                                             <span key={i} className="__tech_chip">{tech}</span>
                                        ))}
                                   </div>
                              </div>

                              {/* 5 Horizontal Scrollable Screenshots Carousel */}
                              <div className="__screenshots_wrapper">
                                   <div className="__carousel_controls">
                                        <span className="__strip_label">App Screenshots</span>
                                        <div className="__nav_arrows">
                                             <button
                                                  className="__arrow_btn"
                                                  onClick={() => handleScroll(project.id, 'left')}
                                                  aria-label="Scroll Left"
                                             >
                                                  <ChevronLeft />
                                             </button>
                                             <button
                                                  className="__arrow_btn"
                                                  onClick={() => handleScroll(project.id, 'right')}
                                                  aria-label="Scroll Right"
                                             >
                                                  <ChevronRight />
                                             </button>
                                        </div>
                                   </div>

                                   <div
                                        className="__horizontal_scroll_container"
                                        ref={(el) => (scrollContainerRefs.current[project.id] = el)}
                                   >
                                        {project.appImages.map((img, index) => (
                                             <div
                                                  key={index}
                                                  className="__phone_mockup_item"
                                                  onClick={() => setSelectedImage({ url: img.url, title: `${project.name} - ${img.caption || img.title}` })}
                                             >
                                                  <div className="__phone_frame">
                                                       {/* <div className="__phone_camera"></div> */}
                                                       <img src={img.url} alt={img.title} className="__screen_img" />
                                                       <div className="__zoom_overlay">
                                                            <ZoomIn />
                                                            <span>Preview</span>
                                                       </div>
                                                  </div>
                                                  <div className="__caption_pill">
                                                       {img.caption || `Screen ${index + 1}`}
                                                  </div>
                                             </div>
                                        ))}
                                   </div>
                              </div>
                         </div>
                    ))}
               </div>

               {/* Fullscreen Lightbox Modal for Screenshots */}
               {selectedImage && (
                    <div className="__lightbox_modal" onClick={() => setSelectedImage(null)}>
                         <div className="__modal_content" onClick={(e) => e.stopPropagation()}>
                              <button className="__close_modal_btn" onClick={() => setSelectedImage(null)}>
                                   <Close />
                              </button>
                              <img src={selectedImage.url} alt={selectedImage.title} className="__modal_img" />
                              <div className="__modal_title">{selectedImage.title}</div>
                         </div>
                    </div>
               )}
          </section>
     );
};

export default AppShowcase;
